// 防抖函数
let debounceTimer = null
export function debounce (fn, delay = 500) {
  return function () {
    if (debounceTimer) {
      clearTimeout(debounceTimer)
    }
    debounceTimer = setTimeout(() => {
      // 放执行函数带参数时，就会用到，例如 fn(1, 2, 3)
      fn.apply(this, arguments)
      debounceTimer = null
    }, delay)
  }
}

/**
 * @description 节流(第一次不触发，最后一次触发)
 * @param {Function} fn 业务函数
 * @param {Number} delay 节流延时，单位：毫秒
 */
// let throttleTimer = null
//  export function throttle(fn, delay = 200) {
// 	return function() {
// 		if (throttleTimer) {
// 			return
// 		}
// 		throttleTimer = setTimeout(() => {
// 			fn.apply(this, arguments)
// 			throttleTimer = null
// 		}, delay)
// 	}
// }

/**
 * @description 节流(第一次触发，最后一次不触发)
 * @param {Function} fn 业务函数
 * @param {Number} delay 节流延时，单位：毫秒
 */
// 记录上一次函数触发的时间
let lastTime = 0
export function throttle(fn, delay) {
  return function() {
      // 记录当前函数触发的时间
      var nowTime = Date.now()
      if (nowTime - lastTime > delay) {
          // 修正this指向问题
          fn.call(this)
          // 同步时间
          lastTime = nowTime
      }
  }
}
